import { ButtonPrimary, Spinner } from 'app/components';
import {
  StyledCtContainer,
  StyledSubtitle,
  StyledTitle,
} from '../ConsignedStep.styles';

type AwaitingComponentProps = {
  backStep: () => void;
  hideSubtitle: boolean;
  dataprevMessage?: string;
};
const AwaitingComponent = ({
  backStep,
  hideSubtitle,
  dataprevMessage,
}: AwaitingComponentProps) => {
  return (
    <StyledCtContainer>
      <Spinner />
      <br />
      <StyledTitle>Consulta em andamento, aguarde.</StyledTitle>
      {dataprevMessage ? (
        <StyledSubtitle>{dataprevMessage}</StyledSubtitle>
      ) : (
        !hideSubtitle && (
          <StyledSubtitle>
            Estamos aguardando a resposta do consignatário.
          </StyledSubtitle>
        )
      )}
      <ButtonPrimary
        typeVariant="outline"
        onClick={backStep}
        style={{ width: '15rem', marginTop: '2rem' }}
      >
        Cancelar consulta
      </ButtonPrimary>
    </StyledCtContainer>
  );
};

export default AwaitingComponent;
